import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { fmtDateTime } from "@/lib/format";
import { BellRing } from "lucide-react";

export default function Notifications() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/platform/notifications").then((r) => setItems(r.data));
  }, []);

  return (
    <div className="space-y-8" data-testid="platform-notifications-page">
      <PageHeader
        eyebrow="Activity"
        title="Notifications"
        description="New subscriptions, cancellations, and system events."
      />

      <div className="grid-surface divide-y divide-stone-100">
        {items.length === 0 ? (
          <div className="p-10 text-center text-stone-400 overline">No notifications yet</div>
        ) : (
          items.map((n) => (
            <div key={n.id} className="p-5 flex gap-4 items-start" data-testid={`notification-${n.id}`}>
              <div className="w-8 h-8 bg-brand-100 border border-brand-500 flex items-center justify-center shrink-0">
                <BellRing size={14} className="text-brand-600" />
              </div>
              <div className="flex-1">
                <div className="font-display font-bold text-stone-950">{n.title}</div>
                <div className="text-sm text-stone-600 mt-1">{n.body}</div>
                <div className="text-xs text-stone-400 mt-2 font-mono">{fmtDateTime(n.created_at)}</div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
